<template>
  <v-card :loading="loading" class="pa-4" flat>
    <vue-table :data="data" :headers="headers" :loading="loading" @change="onChange">
      <template v-slot:filters="{props, perPage}">
        <v-row no-gutters>
          <v-col class="pa-2" cols="12" lg="4" md="6">
            <v-text-field v-model="props.search" append-icon="mdi-magnify" clear-icon="mdi-close-circle-outline"
                          clearable dense hide-details label="جستجو" outlined/>
          </v-col>
        </v-row>
      </template>

      <template v-slot:advertise_id={item}>
        <a v-if="!!item.advertise && !!item.advertise.data && !!item.advertise.data.token"
           :href="`https://divar.ir/v/${item.advertise.data.token}`" target="_blank">
          <div class="badge badge-info">{{ item.advertise_id }}</div>
        </a>

        <template v-else>
          {{ item.advertise_id }}
        </template>
      </template>

      <template v-slot:amount="{item}">
        {{ persian(price(item.amount)) }} ﷼
      </template>

      <template v-slot:deleted_at="{item}">
        <v-chip :color="!!item.deleted_at ? 'success' : 'red'" class="rounded-lg white--text" small>
          {{ !!item.deleted_at ? 'پرداخت شده' : 'منتظر پرداخت' }}
        </v-chip>
      </template>

      <template v-slot:available_at="{item}">
        <v-chip :color="item.deleted_at ? '#93a6f7' : item.available_at > 0 ? '#f81048' : '#fb9678'" class="rounded-lg"
                small>
          {{ secondToHuman(item.available_at) }}
        </v-chip>
      </template>

      <template v-slot:action="{item}">
        <pay-list-buttons :item="item"/>
      </template>
    </vue-table>
  </v-card>
</template>

<script>
import {Axios2} from "@/main";
import {debounce} from "@/custom";
import PayListButtons from "@/view/pages/ads/divar/payListButtons.vue";

export default {
  name: "payList",

  components: {PayListButtons},

  data: () => ({
    data: {},
    tableProps: {
      page: 1,
      length: 10,
      search: ''
    },
    headers: [{
      value: 'id', text: 'شناسه', align: 'center', sortable: false
    }, {
      value: 'title', text: 'عنوان آگهی', align: 'center', sortable: false
    }, {
      value: 'advertise_id', text: 'آگهی', align: 'center', sortable: false
    }, {
      value: 'amount', text: 'قیمت', align: 'center', sortable: false
    }, {
      value: 'title', text: 'نوع ارتقاع', align: 'center', sortable: false
    }, {
      value: 'created_at_p', text: 'تاریخ ثبت', align: 'center', sortable: false
    }, {
      value: 'available_at', text: 'تاریخ ارسال', align: 'center', sortable: false
    }, {
      value: 'deleted_at', text: 'وضعیت پرداخت', align: 'center', sortable: false
    }, {
      value: 'action', text: 'مدیریت', align: 'center', sortable: false
    },],
    loading: false,
  }),

  mounted() {
    this.fetch()
  },

  methods: {
    fetch(params = this.tableProps) {
      this.loading = true

      Axios2.get('/payment', {
        params
      })
        .then(({data}) => this.data = data.data)
        .catch(({response}) => console.log('failed to get payment list: ', response))
        .finally(() => this.loading = false)
    },
    onChange(e) {
      this.loading = true
      this.tableProps = {
        ...this.tableProps,
        ...e
      }

      this.$nextTick(() => {
        this.fetch()
      })
    },
    secondToHuman(second) {
      const moment = require('moment-jalaali')
      moment.locale('fa')

      return moment(second).calendar(null, {
        sameElse: 'jYYYY/jMM/jDD HH:mm:ss'
      })

      const suffix = second > 0 ? ' دیگر ' : ' پیش ';

      second = Math.abs(Number(second));
      let day = Math.floor(second / 86400)
      let hour = Math.floor(second % 86400 / 3600);
      let minutes = Math.floor(second % 3600 / 60);
      second = Math.floor(second % 3600 % 60);

      return `${Math.abs(day)} روز و ${Math.abs(hour)} ساعت و ${Math.abs(minutes)} دقیقه و  ${Math.abs(second)} ثانیه` + suffix;
    }
  }
}
</script>

<style scoped>

</style>